import { createClient } from "@supabase/supabase-js";

import { SUPABASE_URL, SUPABASE_KEY } from "../constants";

export const db = createClient(SUPABASE_URL, SUPABASE_KEY);
